import { z } from 'zod';

export const searchGrammarPointsV1RequestSchema = z.object({
  q: z.string().trim().min(1).max(100),
});

export type ISearchGrammarPointsV1Request = z.infer<typeof searchGrammarPointsV1RequestSchema>;
